import React from 'react';
import { motion } from 'framer-motion';
import { OfferSelector } from '../ui/OfferSelector';
export function OfferBlock() {
  return <section id="oferta" className="py-20 px-4 bg-black relative overflow-hidden scroll-mt-16" data-id="element-127">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand/10 rounded-full blur-[100px] pointer-events-none" data-id="element-128" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-dark-card border-2 border-brand rounded-2xl md:rounded-3xl p-5 md:p-8 box-glow" data-id="element-130">
          <div className="text-center mb-6" data-id="element-131">
            <div className="inline-block bg-brand text-white font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 text-xs md:text-sm" data-id="element-132">
              OFERTA ESPECIAL DE LANZAMIENTO
            </div>
            <h2 className="text-2xl md:text-3xl font-display uppercase text-white mb-1" data-id="element-133">
              Entrena en Casa™ + 3 Bonus
            </h2>
            <p className="text-sm md:text-base text-gray-400" data-id="element-134">
              Acceso inmediato · Pago 100% seguro
            </p>
          </div>

          <OfferSelector ctaLabel="QUIERO EMPEZAR AHORA" data-id="element-135" />
        </motion.div>
      </div>
    </section>;
}